import { Outlet, createFileRoute } from '@tanstack/react-router';

import { DemandPartnerDetailsPage } from '../features/demand/partners/components/DemandPartnerDetailsPage/DemandPartnerDetailsPage';

export const Route = createFileRoute('/demand/partners/$demandPartnerId/details')({
  component: DemandPartnerDetailsRoute,
});

function DemandPartnerDetailsRoute() {
  const { demandPartnerId } = Route.useParams();
  return (
    <DemandPartnerDetailsPage demandPartnerId={demandPartnerId}>
      <Outlet />
    </DemandPartnerDetailsPage>
  );
}
